import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import Card from "@/components/UI/Card/Card";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section08Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const IntegrationsSection = ({ job, page, section, ...props }: Section08Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Integrations?.length > 0 && (
          <div className="grid grid-flow-col grid-rows-1 gap-10 lg:grid-rows-3">
            {section?.Integrations?.map((item: any) => {
              return (
                <Card className="flex rounded-md" key={item?.id}>
                  <div className="flex flex-1 flex-col gap-4 p-6">
                    <div className="flex gap-4">
                      {item?.Image?.data?.attributes && (
                        <div>
                          <Image
                            alt={item?.Image?.data?.attributes?.alternativeText}
                            className="w-12 rounded-full"
                            src={item?.Image?.data?.attributes?.url}
                            width={item?.Image?.data?.attributes?.width ?? "100"}
                            height={item?.Image?.data?.attributes?.height ?? "100"}
                          />
                        </div>
                      )}
                      <div>
                        <div>{item?.Title}</div>
                        <div className="text-xs text-vpGray-700">{item?.Subtitle}</div>
                      </div>
                    </div>
                    <div>{item?.Body}</div>
                  </div>
                  {item?.Underline && (
                    <div className="flex items-center gap-2 px-6 py-2">
                      <div className="text-vpGray-700">{item?.Underline}</div>
                    </div>
                  )}
                </Card>
              );
            })}
          </div>
        )}
        {section?.Button && (
          <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
            <Button className="mx-auto" size="large">
              {section?.Button?.Value}
            </Button>
          </Link>
        )}
      </SectionContainer>
    </Section>
  );
};

export default IntegrationsSection;
